<template>
  <div class="backdrop">
    <div class="backdrop-top">
      <div class="title-box">
        <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>选择物品</span>
      </div>
      <div class="tab-wrapper">
        <div class="tab-repair">操作类型：采购申请</div>
        <div class="tab-head">
          <div :class="{active: curItem === 1}" @click="tab(1)"><img v-if="curItem == 1" src="../../../assets/images/material-scan-icon2.png"><img v-else src="../../../assets/images/material-scan-icon.png">扫条码</div>
          <div :class="{active: curItem === 2}" @click="tab(2)"><img v-if="curItem == 2" src="../../../assets/images/material-goods-icon2.png"><img v-else src="../../../assets/images/material-goods-icon.png">选商品</div>
          <div :class="{active: curItem === 3}" @click="tab(3)"><img v-if="curItem == 3" src="../../../assets/images/material-search-icon2.png"><img v-else src="../../../assets/images/material-search-icon.png">搜索</div>
        </div>
        <div class="tab-content">
          <div v-if="curItem == 1" class="scan">
            <div class="scan-content">
              <img src="../../../assets/images/scan.png" @click="scanCode">
            </div>
          </div>
          <div>
            <div class="tab-classify" v-if="curItem == 2">
              <div class="classify-title" @click="classifyClick">{{category_name}}<img src="../../../assets/images/material-crudejt-down.png"></div>
            </div>
            <div v-if="curItem == 3">
              <div class="common searchbox-wrapper">
                <input type="text" placeholder="请输入物品名称/条码" v-model="keywords" @input="getGoodsLists()">
                <img class="searchbox-close" @click='cleanText' src="../../../assets/images/repairman-search-close.png">
              </div>
            </div>
            <div  v-if="goodsList && (curItem == 2 || keywords)" class="tab-goodslist" v-for="(goods, goods_key) in goodsList" :key="goods_key">
              <img v-if="goods.image_url" class="goodsimg" :src="goods.image_url">
              <img v-else class="goodsimg" src="../../../assets/images/no-picture.jpg">
              <div class="goodsdetail">
                <div class="title">{{goods.goods_name}}</div>
                <div>{{goods.goods_num}}</div>
                <!-- <div>单位：{{goods.unit}}</div> -->
                <div>当前库存：{{goods.total_goods_count}}</div>
              </div>
              <div v-if="selecte_lists[goods.goods_id]" class="goodsnumber">
                <img class="editimg" @click="addclick(goods_key)" src="../../../assets/images/material-goods-edit.png">
                <div>数量：{{selecte_lists[goods.goods_id]['goods_count']}}</div>
              </div>
              <img v-else class="addimg" @click="addclick(goods_key)" src="../../../assets/images/material-goods-add.png">
            </div>
            <div v-if="see_more" @click="getGoodsLists(2)" class="more">- 点击查看更多 -</div>
          </div>
        </div>
      </div>
    </div>
    <div class="backdrop-bottom">
      <div class="goodsdetailed" @click="selectgoods">
        <div>商品种类：{{total_goods_kind}} 种</div>
        <div>总件数：{{total_goods_count}}</div>
        <img class="goodsdetailed-img" src="../../../assets/images/right_jt.png">
      </div>
      <button @click="submit">保存</button>
    </div>
    <!-- 添加进货框 -->
    <div class="purchase-box" v-if="purchaseBox">
      <div class="purchase-content"  style="margin-top: -40px;">
        <div class="purchase-goods">
          <img v-if="selecte_image_url" class="editimg" :src="selecte_image_url">
          <img v-else class="editimg" src="../../../assets/images/no-picture.jpg">
          <div class="goods-detail">
            <div class="title">{{selecte_goods_name}}</div>
            <div>{{selecte_goods_num}}</div>
            <div>库存：{{selecte_goods_count}}</div>
          </div>
        </div>
        <div class="purchase-number">出货数量：<input type="number" ref="input" v-model="num_value" @input="input" /></div>
        <div class="purchase-number">品牌：<input type="brand" ref="input" v-model="brand_value" @input="input" /></div>
        <div class="purchase-number">规格型号：<input type="specification" ref="input" v-model="specification_value" @input="input" /></div>
        <div class="purchase-number">用途：<input type="purpose" ref="input" v-model="purpose_value" @input="input" /></div>
        <div class="purchase-button">
          <button @click="cancel">取消</button>
          <button @click="confirm">确定</button>
        </div>
      </div>
    </div>
    <!-- 已选商品 -->
    <div class="select-mask" v-if="selectGoods">
      <div class="select-mask-inner" style="height: 100%;background-color: #f6f6f6;">
        <div class="">
          <div class="title-box">
            <img src="../../../assets/images/close.png" @click="selectgoodsclose"><span>已选物品</span>
          </div>
          <div class="select-goods">
            <div class="select-goods-item">
              <div class="item-info">物品/条码</div>
              <div class="item-number" style="padding-top: 0;">数量</div>
            </div>
            <div class="select-goods-item" v-for="(goods_id, goods_key) in sort_selecte_lists" :key="goods_key">
              <div class="item-info">
                <div>{{selecte_lists[goods_id].goods_name}}</div>
                <div>{{selecte_lists[goods_id].goods_num}}</div>
              </div>
              <div class="item-number">
                <img class="delete" src="../../../assets/images/repair-del.png" @click="deleteGoods(goods_id)">
                <img class="jia" src="../../../assets/images/jian.png" @click="changeGoods(goods_id,'jian')">
                <div class="num"><input type="text" v-model="selecte_lists[goods_id]['goods_count']" /></div>
                <img class="jia" src="../../../assets/images/jia.png" @click="changeGoods(goods_id,'jia')">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 选择分类 -->
    <div class="select-mask" v-if="classifyPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择资产分类<img class="close-mask" @click="classifyClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="classifyData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectCategory"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'RequisitionSelecteGoods',
  metaInfo: {
    title: '选择物品'
  },
  data () {
    return {
      curItem: 2,
      category_id: 0,
      category_name: '全部分类',
      classifyPopup: false, // 分类
      classifyData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      page: 0, // 页码
      see_more: false,
      goodsList: [],
      num_value: '',
      purchaseBox: false, // 选择商品框
      selecte_goods_id: 0,
      selecte_goods_name: '',
      selecte_goods_num: 0,
      selecte_goods_count: 0,
      selecte_image_url: '',
      selecte_goods_price: 0,
      selecte_lists: {},
      keywords: '',
      repair_status: false,
      total_goods_count: 0, // 总件数
      total_goods_kind: 0, // 商品种类
      goods_lists: [], // 编辑获取的出库单信息
      operate_log: [], // 编辑获取的操作日志
      input_goods_num: '',
      selectGoods: false,
      sort_selecte_lists: [],
      brand_value: '',
      specification_value: '',
      purpose_value: '',
      requisition_type: ''
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId', 'village_member_id'])
  },
  created () {
    console.log('this.$route.query:')
    console.log(this.$route.query)
    this.requisition_id = this.$route.query.requisition_id
    // 添加单据页面返回数据
    if (this.$route.query.selecte_goods_lists) {
      this.selecte_lists = JSON.parse(this.$route.query.selecte_goods_lists)
      this.checkGoods()
    }
    // 申请分类（龙翔集团）
    if (this.$route.query.requisition_type) {
      this.requisition_type = this.$route.query.requisition_type
    }
    // 编辑获取已选商品列表
    if (this.requisition_id) {
      this.getSelectGoodsLists()
    }
    this.getGoodsLists()
    if (this.requisition_type === '') {
      this.getCategoryTree()
    }

    let url = window.location.href.split('#')[0]
    console.log(url)
    this.axios.post('/wechat/index/getticket', {
      url,
      village_id: this.villageId
    }).then((res) => {
      this.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.data.signature, // 必填，签名
        jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表 hideMenuItems
      })
      this.wx.ready(() => {
        console.log('成功')
      })
      this.wx.error(function (res) {
        console.log('失败')
      })
    })
  },
  methods: {
    ...mapMutations(['changeArgs']),
    // 编辑获取已选商品列表
    getSelectGoodsLists () {
      console.log('this.requisition_id:')
      console.log(this.requisition_id)
      this.axios.post('/wechat/Purchase/getRequisitionInfo', {
        member_id: this.memberId,
        village_id: this.villageId,
        requisition_id: this.requisition_id
      }).then((res) => {
        console.log('getInvoiceInfo:')
        console.log(res.data)
        if (res.data.status === 1) {
          this.goods_lists = res.data.data.goods
          this.operate_log = res.data.data.operate_log
          if (this.goods_lists) {
            for (var j = 0; j < this.goods_lists.length; j++) {
              this.selecte_lists[this.goods_lists[j]['goods_id']] = {
                'goods_id': this.goods_lists[j]['goods_id'],
                'goods_num': this.goods_lists[j]['goods_num'],
                'goods_name': this.goods_lists[j]['goods_name'],
                'goods_count': parseFloat((this.goods_lists[j]['requisition_count'])),
                'price': parseFloat((this.goods_lists[j]['price'])),
                'brand': this.goods_lists[j]['brand'],
                'specification': this.goods_lists[j]['specification'],
                'purpose': this.goods_lists[j]['purpose']
              }
              this.sort_selecte_lists.unshift(this.goods_lists[j]['goods_id'])
              this.total_goods_count = parseFloat(this.goods_lists[j]['requisition_count']) + parseFloat(this.total_goods_count) // 总件数
            }
            this.total_goods_kind = this.goods_lists.length // 商品种类
          }
        } else {
          this.$toast({
            message: res.data.info,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    getGoodsLists (type = 1) {
      this.loading = true
      var goodsArr = this.goodsList
      if (type === 2) {
        // 查看更多
      } else {
        // 搜索条件有变化，需重新获取列表 和 统计数据
        this.goodsList = []
        this.page = 0
        this.totalNum = 0
        goodsArr = []
      }
      this.axios.post('/wechat/Goods/goodsList', {
        member_id: this.memberId,
        village_id: this.villageId,
        category_id: this.category_id,
        keywords: this.keywords,
        page: this.page + 1,
        requisition_type: this.requisition_type
      }).then((res) => {
        console.log('getGoodsLists:')
        console.log(res)
        if (res.data.status === 1) {
          this.goodsList = goodsArr.concat(res.data.data.goods_list)
          console.log(this.goodsList)
          this.totalNum = res.data.data.total
          this.page = res.data.data.page
          if (this.goodsList.length >= res.data.data.total || this.goodsList.length === 0) {
            this.see_more = false
          } else {
            this.see_more = true
          }
          if (this.requisition_type) {
            console.log('category:::::')
            console.log(res.data.data.category)
            if (res.data.data.category) {
              this.classifyData = [{id: 0, label: '全部分类'}].concat(res.data.data.category)
            }
          }
          this.loading = false
        }
      })
    },
    // 切换
    tab (e, status = '') {
      this.curItem = e
      this.keywords = ''
      this.see_more = false
      if (e === 2 && status !== 'scanCode') {
        this.getGoodsLists()
      }
    },
    // 添加商品
    addclick (key) {
      this.num_value = ''
      this.brand_value = this.goodsList[key].brand
      this.specification_value = this.goodsList[key].specification
      this.purpose_value = this.goodsList[key].purpose
      this.selecte_goods_id = this.goodsList[key].goods_id
      this.selecte_goods_name = this.goodsList[key].goods_name
      this.selecte_goods_num = this.goodsList[key].goods_num
      this.selecte_goods_count = this.goodsList[key].total_goods_count
      this.selecte_image_url = this.goodsList[key].image_url
      this.selecte_goods_price = this.goodsList[key].price
      if (this.selecte_lists[this.goodsList[key].goods_id] !== undefined) {
        this.num_value = this.selecte_lists[this.goodsList[key].goods_id]['goods_count']
        this.brand_value = this.selecte_lists[this.goodsList[key].goods_id]['brand']
        this.specification_value = this.selecte_lists[this.goodsList[key].goods_id]['specification']
        this.purpose_value = this.selecte_lists[this.goodsList[key].goods_id]['purpose']
      }
      this.purchaseBox = true
      // input自动获取焦点
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    },
    // 取消
    cancel () {
      this.purchaseBox = false
    },
    // 确定
    confirm () {
      if (this.num_value === 0 || this.num_value === '') {
        this.$toast({
          message: '数量必填',
          duration: 3000
        })
        return false
      }
      if (this.selecte_goods_id === 0) {
        this.$toast({
          message: '请选择物品',
          duration: 3000
        })
        return false
      } else {
        if (parseFloat(this.num_value) === 0 && this.selecte_lists[this.selecte_goods_id]) {
          delete this.selecte_lists[this.selecte_goods_id]
          if (this.sort_selecte_lists.indexOf(parseInt(this.selecte_goods_id)) > -1) {
            this.sort_selecte_lists.splice(this.sort_selecte_lists.indexOf(parseInt(this.selecte_goods_id)), 1)
          }
        } else {
          this.selecte_lists[this.selecte_goods_id] = {'goods_id': this.selecte_goods_id, 'goods_num': this.selecte_goods_num, 'goods_name': this.selecte_goods_name, 'goods_count': this.num_value, 'price': this.selecte_goods_price, 'brand': this.brand_value, 'specification': this.specification_value, 'purpose': this.purpose_value}
          console.log('添加')
          console.log(this.purpose_value)
          console.log(this.selecte_lists)
          if (parseInt(this.sort_selecte_lists.indexOf(this.selecte_goods_id)) === -1) {
            this.sort_selecte_lists.unshift(this.selecte_goods_id)
          }
        }
        this.checkGoods()
      }
      this.purchaseBox = false
    },
    cutOneClick (goodsId) {
      if (parseFloat(this.selecte_lists[goodsId]['goods_count']) > 1) {
        this.selecte_lists[goodsId]['goods_count'] = parseFloat(this.selecte_lists[goodsId]['goods_count']) - 1
      } else {
        delete this.selecte_lists[goodsId]
      }
      console.log('delete - goods:')
      console.log(this.selecte_lists)
    },
    addOneClick (goodsId) {
      this.selecte_lists[goodsId]['goods_count'] = parseFloat(this.selecte_lists[goodsId]['goods_count']) - 1
      console.log('add - goods:')
      console.log(this.selecte_lists)
    },
    deleteClick (goodsId) {
      delete this.selecte_lists[goodsId]
      console.log('add - delete:')
      console.log(this.selecte_lists)
    },
    submit () {
      if (Object.keys(this.selecte_lists).length === 0) {
        this.$toast({
          message: '请选择商品',
          duration: 5000
        })
        return false
      }
      this.$router.push({name: 'RequisitionAdd', query: {selecteLists: JSON.stringify(this.selecte_lists), requisition_id: this.requisition_id, requisition_type: this.requisition_type}})
    },
    // 扫码
    scanCode () {
      let that = this
      this.wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          var str = result.split(',')
          that.input_goods_num = str[1]
          that.checkCode()
        }
      })
    },
    // 资产编码校验
    checkCode () {
      if (this.input_goods_num === '') {
        this.$toast({
          message: '未获取到商品编码',
          duration: 2000
        })
        return false
      }
      // 判断商品是否存在
      this.axios.post('/wechat/goods/goodsDetail', {
        member_id: this.memberId,
        village_id: this.villageId,
        goods_num: this.input_goods_num
      }).then((res) => {
        if (res.data.data) {
          var goodsInfo = res.data.data
          console.log(goodsInfo)
          this.goodsList = []
          this.page = 0
          this.totalNum = 0
          this.see_more = false
          this.goodsList[0] = goodsInfo
          console.log('this.goodsList[0]:')
          console.log(this.goodsList[0])
          this.tab(2, 'scanCode')
        } else {
          this.$toast({
            message: '未找到物品' + this.input_goods_num,
            duration: 5000
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    input (event) {
      console.log(event.target.value)
      if (event.target.value === 0 || event.target.value === '') {}
    },
    getCategoryTree () {
      this.axios.post('/wechat/basic_info/getCategoryTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.classifyData = [{id: 0, label: '全部分类'}].concat(res.data.data)
        }
      })
    },
    // 点击分类
    classifyClick () {
      this.classifyPopup = true
    },
    // 关闭分类弹出
    classifyClose () {
      this.classifyPopup = false
    },
    // 点击空白地方关闭
    clickBlank () {
      this.classifyPopup = false
    },
    selectCategory (data) {
      this.category_id = data.id
      this.category_name = data.label
      this.clickBlank()
      this.getGoodsLists()
    },
    findUser () {
      this.userData = []
      var keywords = this.userKeywords
      let that = this
      this.allUserData.forEach(function (detail) {
        if (detail.label.indexOf(keywords) !== -1) {
          that.userData.push(detail)
        }
      })
    },
    cleanText () {
      this.keywords = ''
    },
    selectgoods () {
      this.selectGoods = true
    },
    selectgoodsclose () {
      this.selectGoods = false
    },
    changeGoods (key, type) {
      var goodsCount = 0
      if (type === 'jia') {
        goodsCount = parseInt(this.selecte_lists[key]['goods_count']) + 1
      }
      if (type === 'jian') {
        goodsCount = parseInt(this.selecte_lists[key]['goods_count']) - 1
      }
      if (goodsCount === 0) {
        this.deleteGoods(key)
      } else {
        this.selecte_lists[key]['goods_count'] = goodsCount
        var data = this.selecte_lists[key]
        delete this.selecte_lists[key]
        this.$set(this.selecte_lists, key, data)
        this.checkGoods()
      }
    },
    deleteGoods (key) {
      var info = this.selecte_lists
      delete this.selecte_lists[key]
      this.$set(this, 'selecte_lists', {})
      this.$set(this, 'selecte_lists', info)
      if (this.sort_selecte_lists.indexOf(parseInt(key)) > -1) {
        this.sort_selecte_lists.splice(this.sort_selecte_lists.indexOf(parseInt(key)), 1)
      }
      this.checkGoods()
      // if (Object.keys(this.selecte_lists).length < 1) {
      //   this.selectGoods = false
      // }
    },
    checkGoods () {
      this.total_goods_count = 0
      for (var key of Object.keys(this.selecte_lists)) {
        this.total_goods_count = parseFloat(this.selecte_lists[key]['goods_count']) + parseFloat(this.total_goods_count) // 总件数
      }
      this.total_goods_kind = Object.keys(this.selecte_lists).length// 商品种类
    }
  }
}
</script>
<style scoped>
.common {
  padding: 15px 10px;
}
.backdrop {
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 68px);
}
.tab-wrapper {
  font-size: 15px;
  width: 100%;
  height: calc(100% - 42px);
}
.tab-wrapper .tab-head {
  display: flex;
  background-color: #ffffff;
}
.tab-wrapper .tab-head div {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  color: #2f2f2f;
}
.tab-wrapper .tab-head div img {
  width: 18px;
  height: 18px;
  vertical-align: top;
  padding: 2px 6px 0 0;
}
.tab-wrapper .tab-head .active {
  color: #7190fd;
  position: relative;
}
.tab-wrapper .tab-head .active::after {
  content: '';
  position: absolute;
  left: 50%;
  margin-left: -27%;
  bottom: 0;
  width: 55%;
  height: 2px;
  background-color: #7190fd;
}
.tab-wrapper .tab-content {
  width: 100%;
  height: calc(100% - 70px);
  overflow-y: auto;
}
.tab-wrapper .tab-goodslist {
  display: flex;
  background-color: #ffffff;
  padding: 12px;
}
.tab-wrapper .tab-goodslist .goodsimg {
  width: 75px;
  height: 75px;
}
.tab-wrapper .tab-goodslist .goodsdetail {
  flex: 1;
  padding: 0 12px;
}
.tab-wrapper .tab-goodslist .goodsdetail div {
  color: #989898;
  font-size: 13px;
}
.tab-wrapper .tab-goodslist .goodsdetail .title {
  font-size: 15px;
  color: #43464f;
  font-weight: 700;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.tab-wrapper .tab-goodslist .addimg {
  width: 20px;
  height: 20px;
  margin-top: 27px;
}
.tab-wrapper .tab-goodslist .goodsnumber {
  font-size: 13px;
  color: #2f2f2f;
  text-align: right;
}
.tab-wrapper .tab-goodslist .goodsnumber .editimg {
  width: 20px;
  height: 20px;
  margin-top: 5px;
}
.tab-wrapper .tab-goodslist .goodsnumber div {
  margin-top: 2px;
}
.tab-classify {
  padding: 10px 15px;
  color: #8f8f8f;
  font-size: 14px;
}
.tab-classify .classify-title img {
  width: 10px;
  height: 10px;
  padding-left: 8px;
}
.searchbox-wrapper {
  display: flex;
  position: relative;
  margin-bottom: 0;
  padding-bottom: 0;
  padding-top: 10px;
  padding-bottom: 5px;
}
.searchbox-wrapper input {
  flex: 1;
  height: 30px;
  background-color: #f8f8f8;
  border-radius: 14px;
  border: none;
  padding: 0 28px 0 30px;
  background-image: url(../../../assets/images/repairman-search.png);
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: 9px center;
  outline: none;
}
.searchbox-wrapper .searchbox-close {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 16px;
  right: 20px;
}
.backdrop-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  background-color: #ffffff;
  display: flex;
  font-size: 14px;
}
.backdrop-bottom button {
  width: 100px;
  height: 60px;
  line-height: 59px;
  background-color: #ff7c12;
  border-radius: none;
  border: none;
  color: #ffffff;
  font-size: 15px;
}
.backdrop-bottom .goodsdetailed {
  flex: 1;
  padding: 9px 20px;
  position: relative;
}
.backdrop-bottom .goodsdetailed div {
  line-height: 22px;
}
.backdrop-bottom .goodsdetailed-img {
  position: absolute;
  top: 50%;
  right: 20px;
  margin-top: -6px;
  width: 12px;
  height: 12px;
}
.purchase-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 2;
  align-items: center;
  justify-content: center;
  display: flex;
}
.purchase-box .purchase-content {
  background-color: #ffffff;
  border-radius: 5px;
  width: 70%;
}
.purchase-box .purchase-content .purchase-goods {
  padding: 15px;
  display: flex;
  font-size: 14px;
  color: #8f8f8f;
}
.purchase-box .purchase-content .purchase-goods img {
  width: 60px;
  height: 60px;
}
.purchase-box .purchase-content .purchase-goods .goods-detail {
  flex: 1;
  padding-left: 10px;
}
.purchase-box .purchase-content .purchase-goods .goods-detail .title {
  font-size: 15px;
  color: #000000;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.purchase-box .purchase-content .purchase-number {
  font-size: 15px;
  padding: 0 15px 15px 15px;
}
.purchase-box .purchase-content .purchase-number input {
  border-radius: 15px;
  border: none;
  height: 28px;
  background-color: #f7f7f7;
  outline: none;
  padding: 0 15px;
  width: 80px;
}
.purchase-box .purchase-content .purchase-button {
  display: flex;
  font-size: 16px;
}
.purchase-box .purchase-content .purchase-button button {
  flex: 1;
  height: 40px;
  background-color: #f7f7f7;
  border: none;
  margin: 0;
}
.purchase-box .purchase-content .purchase-button button:first-child {
  border-bottom-left-radius: 5px;
  border-top: 1px solid #f1f1f1;
}
.purchase-box .purchase-content .purchase-button button:last-child {
  background-color: #ff7c12;
  color: #ffffff;
  border-bottom-right-radius: 5px;
}
.scan {
  width: 100%;
  height: 100%;
}
.scan .scan-content {
  width: 100%;
  height: 100%;
  text-align: center;
}
.scan .scan-content img {
  width: 100px;
  height: 100px;
  margin-top: 90px;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
  overflow-y: auto;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
.select-goods .select-goods-item {
  display: flex;
  font-size: 15px;
  background-color: #ffffff;
  padding: 12px;
}
.select-goods .select-goods-item .item-info {
  flex: 1;
  padding-right: 6px;
}
.select-goods .select-goods-item .item-info div {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
}
.select-goods .select-goods-item .item-info div:first-child {
  font-weight: bold;
}
.select-goods .select-goods-item .item-info div:last-child {
  font-size: 13px;
  margin-top: 5px;
}
.select-goods .select-goods-item .item-number {
  padding-top: 10px;
}
.select-goods .select-goods-item .item-number div {
  display: inline-block;
}
.select-goods .select-goods-item .item-number .delete {
  width: 20px;
  height: 20px;
  padding-right: 10px;
}
.select-goods .select-goods-item .item-number img {
  vertical-align: top;
}
.select-goods .select-goods-item .item-number .num input {
  width: 40px;
  font-size: 15px;
  text-align: center;
  outline: none;
  border: none;
  padding: 0;
  border-radius: 0;
  border-bottom: 1px solid #333;
}
.select-goods .select-goods-item .item-number .jia {
  width: 20px;
  height: 20px;
}
.mint-switch-core {
  width: 42px;
  height: 22px;
}
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
.el-tree-node__expand-icon {
  font-size: 18px;
}
.more {
  font-size: 14px;
  text-align: center;
  background-color: #ffffff;
  padding: 10px 0;
}
.tab-wrapper .tab-repair {
  /* width: 100%; */
  font-size: 15px;
  color: #8f8f8f;
  padding: 0 15px 6px 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/purchase/RequisitionSelecteGoods.vue